<script>
export default {
    name: "row-limit",
    inserted(el, binding){
        let rowLimit = binding.value === undefined ? 1 : binding.value;
        if(rowLimit === 0){
            return;
        }
        if(el.childElementCount > 0){
            console.warn("目标元素下面不能包含别的元素，请确保目标元素内只有文字");
            return;
        }
        let css = getComputedStyle(el);
        let textContent = el.textContent.trim();
        let {width, lineHeight, fontFamily, fontSize, fontWeight, fontStyle, paddingLeft, paddingRight} = css;
        lineHeight = parseFloat(lineHeight);
        width = parseFloat(width) - parseFloat(paddingLeft) - parseFloat(paddingRight);
        if(width < 40){
            console.warn("请设置目标元素宽度不小于40px");
        }
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        ctx.font = `${fontStyle} ${fontWeight} ${fontSize}/${lineHeight}px ${fontFamily}`;
        let str = textContent;
        let textWidth = ctx.measureText(str).width;
        let tryText = "";
        if(textWidth > width){
            let arr = [], index = textContent.length - 1;
            while(index > 0){
                tryText = str.substring(0, index);
                textWidth = ctx.measureText(tryText).width;
                if(textWidth > width){
                    index--;
                } else {
                    arr.push(tryText);
                    str = str.substr(index);
                    if(str.length === 0){
                        index = 0;
                    }
                }
            }
            if(arr.length > rowLimit){
                arr = arr.slice(0, rowLimit);
                let lastStr = arr[arr.length - 1];
                arr[arr.length - 1] = lastStr.substr(0, lastStr.length - 2) + "...";
                el.setAttribute("title", textContent);
                el.style.height = lineHeight * rowLimit + "px";
                el.style.overflow = "hidden";
                el.style.whiteSpace = "normal";
                el.innerHTML = arr.join("<br/>");
            }
        }
        canvas = ctx = null;
    }
}
</script>